<script>
import { ref } from 'vue';
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'

import { required, maxLength, minValue } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import VesselProtocolCustomsInformation from './VesselProtocolCustomsInformation.vue';
import VesselProtocolLoading from './VesselProtocolLoading.vue';
import VesselProtocolDischarge from './VesselProtocolDischarge.vue';
import VesselProtocolPrevisionalCommercialInfo from './VesselProtocolPrevisionalCommercialInfo.vue';
import VesselProtocolFinalCommercialInfo from './VesselProtocolFinalCommercialInfo.vue';
import VesselProtocolPayments from './VesselProtocolPayments.vue';
import VesselProtocolDocuments from './VesselProtocolDocuments.vue';
import VesselProtocolReport from './VesselProtocolReport.vue';

export default {
  setup: () => ({
    v$: useVuelidate()
  }),

  components: {
    Button,
    GenericCustomAutocompleteV2,
    Dialog,
    ResponsiveButton,
    VesselProtocolCustomsInformation,
    VesselProtocolLoading,
    VesselProtocolDischarge,
    VesselProtocolPrevisionalCommercialInfo,
    VesselProtocolPayments,
    VesselProtocolFinalCommercialInfo,
    VesselProtocolReport,
    VesselProtocolDocuments
  },
  data() {
    return {
      collapseMainInformation: false,
      collapseTabsPanel: false,
      data: {},
      dataInfo: {},
      assets: {},
      operationReason: "",
      activeTab: 0,
      confirmChangeStatusVisible: false,
      changeImporterExporterDialogVisible: false,
      changeFiscalDestinationDialogVisible: false,
      changeStatusSubmitted: false,
      manageLotsAggregationDialogVisible: false,
      unlinkedLots: [],
      referenceDate: null,
      accertedQuantity: 0,
      netQuantity: 0,
      registryNumber: "",
      statisticValue: 0,
      registryType: null,
      registryDate: null,
      documents: [],
      mrn: null
    }
  },
  validations() {
    return {
      operationReason: { required },
    }
  },
  computed: {
    constants() {
      return CommonConstants;
    },
    utils() {
      return Utils;
    },
    uiPermissions() {
      return this.$store.getters['security/uiPermissions'];
    },
    isDisabled() {
      return this.data.isClosed || this.data.isCanceled
    }
  },
  created() {
    this.config = config.getConfiguration('VesselProtocol');
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'vesselProtocol.page_title');
    this.loadData();
  },
  watch: {
    confirmChangeStatusVisible(newValue) {
      this.operationReason = "";
      if (!newValue) {
        this.$store.dispatch("generic/setLoading", true);
        this.loadData();
      }
    },
    changeFiscalDestinationDialogVisible(newValue) {
      if (!newValue) {
        this.$store.dispatch("generic/setLoading", true);
        this.loadData();
      }
    },
    changeImporterExporterDialogVisible(newValue) {
      if (!newValue) {
        this.$store.dispatch("generic/setLoading", true);
        this.loadData();
      }
    }
  },
  methods: {
    loadData() {
      Service.getVesselProtocolByLotId({ id: this.$route.query.id }, ({ success, data, message }) => {
        this.$store.dispatch("generic/setLoading", false);
        if (success) {
          this.data = data;
          this.data.visibleTabs.push('Report');
          this.config.dataFields.forEach(element => {
            this.dataInfo[element] = data[element];
          });
          this.config.assetsFields.forEach(element => {
            this.assets[element] = data.assets[element];
          });
        } else {

          if(message == 'LOT_IS_NOT_MAIN'){
            let uri = `/vessel-protocol?id=${data.id}`;
            this.$router.push(uri);
          }else{
            this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        }
      })
    },
    changeStatus() {
      this.changeStatusSubmitted = true;
      if (!this.v$.operationReason.$invalid) {
        Service.changeVesselProtocolStatus({
          id: this.data.id,
          isCanceled: this.data.isCanceled,
          isClosed: this.data.isClosed,
          cancellationReason: this.operationReason
        }, ({ success, message }) => {
          this.changeStatusSubmitted = false;
          this.confirmChangeStatusVisible = false;
          if (success) {
            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
          } else {
            this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      }
    },
    changeImporterExporter() {
      Service.manualChangeVesselProtocol({
        vesselProtocolId: this.data.id,
        overrideImporterExporter: true,
        overrideFiscalDestination: false,
        newImporterExporter: this.data.importerExporterId,
        newFiscalDestination: null
      }, ({ success, message }) => {
        this.changeImporterExporterDialogVisible = false;
        if (success) {
          this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
        } else {
          this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
        this.$store.dispatch("generic/setLoading", true);
        this.loadData();
      })
    },
    changeFiscalDestination() {
      Service.manualChangeVesselProtocol({
        vesselProtocolId: this.data.id,
        overrideFiscalDestination: true,
        overrideImporterExporter: false,
        newFiscalDestination: this.data.fiscalDestinationId,
        newImporterExporter: null
      }, ({ success, message }) => {
        this.changeFiscalDestinationDialogVisible = false;
        if (success) {
          this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
        } else {
          this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
        this.$store.dispatch("generic/setLoading", true);
        location.reload();
      })
    },
    manageLotsAggregation() {
      this.manageLotsAggregationDialogVisible = true;
      this.$store.dispatch("generic/setLoading", true);
      Service.checkVesselProtocolLots({ vesselProtocolId: this.data.id }, ({ success, data, message }) => {
        this.$store.dispatch("generic/setLoading", false);
        if (success) {
          this.unlinkedLots = data.unlinkedLots;
        } else {
          this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })
    },
    linkToOtherProtocol(data) {

    },
    linkLot(lotData) {
      this.$store.dispatch("generic/setLoading", true);
      Service.linkLotToVesselProtocol({ vesselProtocolId: this.data.id, movementInstructionLotId: lotData.lotId }, ({ success, data, message }) => {
        this.$store.dispatch("generic/setLoading", false);
        if (success) {
          this.manageLotsAggregationDialogVisible = false;
          this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
        } else {
          this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })
    },
    updateReferenceDate(date) {
      this.referenceDate = date;
    },
    updateAccertedQuantity(gross, net) {
      this.accertedQuantity = gross;
      this.netQuantity = net;
    },
    updateReportData(data) {
      this.statisticValue = data.statisticValue;
      this.registryNumber = data.eRegistrationCode;
      this.registryType = data.registerType;
      this.registryDate = data.registerDate;
      this.mrn = data.mrn;

      if(this.$refs.previsionalCommercialInfo[0]){
        this.$refs.previsionalCommercialInfo[0].loadData();
      }
      if(this.$refs.finalCommercialInfo[0]){
        this.$refs.finalCommercialInfo[0].loadData();
      }
      if(this.$refs.VesselProtocolPaymentsTab[0]){
        this.$refs.VesselProtocolPaymentsTab[0].loadData();
      }
    },
    updateDocuments(documents){
      this.documents = documents;
    },
    updatePayments(){
      this.$refs.VesselProtocolPaymentsTab[0].loadData();
    },
    onReportSaved(){
      this.$refs.VesselProtocolDocumentsTab[0].loadDocuments();
      this.loadData();
    },
    updateVesselProtocolByLotId(){
      this.$confirm.require({
        message: this.$t('messages.generic_confirm_message'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {                  
          this.$store.dispatch("generic/setLoading", true);
          Service.updateVesselProtocolByLotId({ id: this.$route.query.id }, ({ success, message }) => {
            this.$store.dispatch("generic/setLoading", false);
            if (success) {
              this.loadData();
              this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
            } else {
              this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
          })
        },
        reject: () => {
            this.$confirm.close();
        }
      });
    }
  }
}

</script>

<template>
  <main class="vessel-protocol">
    <Dialog :header="$t('vesselProtocol.lotsAggregationManagement')" v-model:visible="manageLotsAggregationDialogVisible"
      :style="{ width: '90vh' }" :modal="true">
      <div class="grid">
        <div class="col-12">
          <DataTable :value="unlinkedLots" :reorderableColumns="false" ref="manageLotsAggregationTable">
            <Column :reorderableColumn="false" :exportable="false" style="width:10%; min-width:8rem">
              <template #body="slotProps">
                <ResponsiveButton icon="pi pi-link" class="grid-action-btn p-button-rounded p-button-outlined"
                  :disabled="slotProps.data.isLinkedToOtherProtocol" @click="linkLot(slotProps.data)"
                  v-tooltip="$t('vesselProtocol.linkToProtocol')" />
                <ResponsiveButton icon="pi pi-external-link" class="grid-action-btn p-button-rounded p-button-outlined"
                  :disabled="true" @click="linkToOtherProtocol(slotProps.data)"
                  v-tooltip="$t('vesselProtocol.linkToOtherProtocol')" />
              </template>
            </Column>
            <Column field="lotCode" :header="$t('vesselProtocol.lotCode')" dataType="string" />
            <Column field="product" :header="$t('product.fk')" dataType="string" />
            <Column field="quantity" :header="$t('quantity')" dataType="string" />
            <Column field="protocolNumber" :header="$t('vesselProtocol.protocolNumber')" dataType="string" />
          </DataTable>
          <!-- <div class="col-12 text-right">
              <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" @click="changeImporterExporterDialogVisible = false" class="p-button-outlined p-button-sm" />
              <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="changeImporterExporter" class="p-button-outlined p-button-sm ml-2" />
            </div> -->
        </div>
      </div>
    </Dialog>
    <Dialog :header="$t('vesselProtocol.confirmOperation')" v-model:visible="confirmChangeStatusVisible"
      :style="{ width: '50vw' }" :modal="true">
      <div class="grid">
        <div class="col-12">
          <label
            :class="{ 'p-error': v$.operationReason && v$.operationReason.$invalid && changeStatusSubmitted }">{{ $t('vesselProtocol.changeStatusReason') }}</label>
          <Textarea type="text" v-model="operationReason"
            :class="{ 'p-invalid': v$.operationReason && v$.operationReason.$invalid && changeStatusSubmitted }"
            class="w-full p-inputtext-sm mt-1" />
          <div
            v-if="(v$.operationReason && v$.operationReason.$invalid && changeStatusSubmitted) || v$.operationReason && v$.operationReason.$pending.$response">
            <small class="p-error" v-for="error in v$.operationReason && v$.operationReason.$silentErrors"
              :key="error.$validator">
              {{ error.$message }}
            </small>
          </div>
        </div>
        <div class="col-12 text-right">
          <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" @click="confirmChangeStatusVisible = false"
            class="p-button-outlined p-button-sm" />
          <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="changeStatus"
            class="p-button-outlined p-button-sm ml-2" />
        </div>
      </div>
    </Dialog>
    <Dialog :header="$t('vesselProtocol.changeImporterExporter')" v-model:visible="changeImporterExporterDialogVisible"
      :style="{ width: '300px' }" :modal="true">
      <div class="grid">
        <div class="col-12">
          <GenericCustomAutocompleteV2 ref="importerExporter" class="w-full p-inputtext-sm"
            v-model="data.importerExporterId" name="importer-exporter-combo" :format="{ label: 'label', value: 'value' }"
            api="masterdata/company-combo"
            :queryField="{isOwner: true}" />
          <div class="col-12 text-right">
            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times"
              @click="changeImporterExporterDialogVisible = false" class="p-button-outlined p-button-sm" />
            <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="changeImporterExporter"
              class="p-button-outlined p-button-sm ml-2" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :header="$t('vesselProtocol.changeFiscalDestination')" v-model:visible="changeFiscalDestinationDialogVisible"
      :style="{ width: '300px' }" :modal="true">
      <div class="grid">
        <div class="col-12">
          <GenericCustomAutocompleteV2 ref="fiscalDestination" :disabled="isDisabled"
            class="w-full p-inputtext-sm" v-model="data.fiscalDestinationId" name="fiscal-destination-combo"
            :format="{ label: 'label', value: 'value' }" api="masterdata/fiscal-destination-combo" />
          <div class="col-12 text-right">
            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times"
              @click="changeFiscalDestinationDialogVisible = false" class="p-button-outlined p-button-sm" />
            <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="changeFiscalDestination"
              class="p-button-outlined p-button-sm ml-2" />
          </div>
        </div>
      </div>
    </Dialog>
    <div class="m-5">
      <div class="grid">
        <div class="col-3 lg:col-2">
          <h4>{{ $t('vesselProtocol.lots') + ': ' + (this.data.lotDescription ?? "-") }}</h4>
        </div>
        <div class="col-3 lg:col-2">
          <Button :label="$t('vesselProtocol.lotsAggregationManagement')" icon="pi pi-sync"
            class="p-button-sm p-button-info mr-2" @click="manageLotsAggregation" />
        </div>
        <div class="col-3 lg:col-2">
          <Button :label="$t('vesselProtocol.updateVesselProtocolButton')" v-if="!uiPermissions('vesselProtocolUpdateButton').isHidden"  icon="pi pi-sync"
            class="p-button-sm p-button-outlined mr-2" @click="updateVesselProtocolByLotId()" />
        </div>
        <div class="col-12 lg:col-5">
          <div class="grid">
            <div class="col-4">
              <h4>{{ $t('vesselProtocol.status') }}</h4>
            </div>
            <div class="col-4">
              <Checkbox name="change-status-closed" v-model="data.isClosed" :binary="true"
                @change="confirmChangeStatusVisible = true" :disabled="!uiPermissions('vesselProtocolChangeStatusButton').isEnabled || data.isCanceled" v-if="!uiPermissions('vesselProtocolChangeStatusButton').isHidden" />
              <label class="ml-2" for="change-status-closed">{{ $t('vesselProtocol.closed') }}</label>
            </div>
            <div class="col-4">
              <Checkbox name="change-status-canceled" v-model="data.isCanceled" :binary="true"
                @change="confirmChangeStatusVisible = true" :disabled="!uiPermissions('vesselProtocolChangeStatusButton').isEnabled || data.isClosed" v-if="!uiPermissions('vesselProtocolChangeStatusButton').isHidden" />
              <label class="ml-2" for="change-status-canceled">{{ $t('vesselProtocol.canceled') }}</label>
            </div>
            <div class="col-12" v-if="data.isClosed">
              <h5 v-if="data.cancellationReason != null">{{ $t('vesselProtocol.closingReason') + ': ' + (this.data.cancellationReason ?? "") }}</h5>
            </div>
            <div class="col-12" v-if="data.isCanceled">
              <h5 v-if="data.cancellationReason != null">{{ $t('vesselProtocol.cancellationReason') + ': ' + (this.data.cancellationReason ?? "") }}</h5>
            </div>
          </div>
        </div>
        <Panel :header="$t('vesselProtocol.mainInformation')" :toggleable="true"
          v-model:collapsed='collapseMainInformation' class="col-12">
          <div class="grid">
            <div class="col-12 lg:col-9">
              <h4 class="mb-3">{{ $t('vesselProtocol.information') }}</h4>
              <div class="grid">
                <div class="col-12 lg:col-4" v-for="value, key in dataInfo" :key="key">
                  <b>{{ $t('vesselProtocol.' + key) + ': ' }}</b>{{ (value ?? "") }}
                </div>
              </div>
            </div>
            <div class="col-12 lg:col-3">
              <h4 class="mb-3">{{ $t('vesselProtocol.assets') }}</h4>
              <div class="grid">
                <div class="col-12" v-for="value, key in assets" :key="key">
                  <b>{{ $t('vesselProtocol.' + key) + ': ' }}</b>{{ (value ?? "") }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <p><b>{{ $t('vesselProtocol.ceeDestinations') + ': ' }}</b>{{ (data.ceeDestinations ?? "") }}</p>
              <p><b>{{ $t('vesselProtocol.extraCeeDestinations') + ': ' }}</b>{{ (data.extraCEEDestinations ?? "") }}</p>
              
            </div>
            <div class="col-12">
              <div class="grid justify-content-end">
                <div class="col-12 lg:col-3">
                  <label for="importer-exporter-combo">
                    <p><b><span class="block">{{ $t('vesselProtocol.importerExporter') + ': ' }}</span></b>{{
                      data.importerExporter }}</p>
                  </label>
                  <Button :label="$t('btn.change')" icon="pi pi-sync" class="p-button-sm p-button-info mr-2"
                    @click="changeImporterExporterDialogVisible = true" :disabled="!uiPermissions('vesselProtocolChangeImporterExporterButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolChangeImporterExporterButton').isHidden" />
                </div>
                <div class="col-12 lg:col-3">
                  <label for="fiscal-destination-combo">
                    <p><b><span class="block">{{ $t('vesselProtocol.fiscalDestination') + ': ' }}</span></b> {{
                      data.fiscalDestination }}</p>
                  </label>
                  <Button :label="$t('btn.change')" icon="pi pi-sync" class="p-button-sm p-button-info mr-2"
                    @click="changeFiscalDestinationDialogVisible = true" :disabled="!uiPermissions('vesselProtocolChangeFiscalDestinationButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolChangeFiscalDestinationButton').isHidden" />
                </div>
              </div>
            </div>
          </div>
        </Panel>
        <Panel :header="$t('vesselProtocol.otherPanels')" :toggleable="true" v-model:collapsed='collapseTabsPanel'
          class="col-12">
          <div class="grid">
            <div class="col-12">
              <TabView class="tab" v-model:activeIndex="activeTab">
                <TabPanel :header="$t('vesselProtocol.tabs.' + tab)" :key="tab" v-for="tab in data.visibleTabs">
                  <template v-if="tab === 'Customs Info'">
                    <VesselProtocolCustomsInformation :vesselProtocolId="data.id" :isDisabled="isDisabled"
                      :fiscalDestination="data.fiscalDestination" @updateReferenceDate="updateReferenceDate" @updateReportData="updateReportData" />
                  </template>
                  <template v-if="tab === 'Loading'">
                    <VesselProtocolLoading :isDisabled="isDisabled" :vesselProtocolId="data.id" @updateAccertedQuantity="updateAccertedQuantity" @update-payments="updatePayments" />
                  </template>
                  <template v-if="tab === 'Discharge'">
                    <VesselProtocolDischarge :isDisabled="isDisabled" :vesselProtocolId="data.id" @updateAccertedQuantity="updateAccertedQuantity" @update-payments="updatePayments" />
                  </template>
                  <template v-if="tab === 'Previsional Commercial Info'">
                    <VesselProtocolPrevisionalCommercialInfo ref="previsionalCommercialInfo" :isDisabled="isDisabled" :vesselProtocolId="data.id" />
                  </template>
                  <template v-if="tab === 'Payments'">
                    <VesselProtocolPayments :isDisabled="isDisabled" :vesselProtocolId="data.id" :direction="data.direction"
                      :referenceDate="new Date(referenceDate)" ref="VesselProtocolPaymentsTab"/>
                  </template>
                  <template v-if="tab === 'Documents'">
                    <VesselProtocolDocuments :isDisabled="isDisabled" :vesselProtocolId="data.id" :voyageNumber="data.voyageNumber"
                      :referenceDate="new Date(referenceDate)" @updateDocuments="updateDocuments" ref="VesselProtocolDocumentsTab" />
                  </template>
                  <template v-if="tab === 'Final Commercial Info'">
                    <VesselProtocolFinalCommercialInfo :isDisabled="isDisabled" :vesselProtocolId="data.id" ref="finalCommercialInfo" />
                  </template>
                  <template v-if="tab ==='Report'">
                  <VesselProtocolReport :isDisabled="isDisabled" @onReportSaved="onReportSaved" :documents="documents" :vesselProtocolId="data.id" :combinedNomenclature="data.combinedNomenclature" :plant="data.plant" :quantity="accertedQuantity" :netQuantity="netQuantity" :protocolNumber="data.protocolNumber" :protocolDate="data.protocolDate" :vessel="data.vessel" :product="data.productDescription" :origin="data.originCountry" :destination="data.destinationCountry" :voyageNumber="data.voyageNumber" :direction="data.direction" :statisticValue="statisticValue" :customer="data.customer" :registryNumber="registryNumber" :registryType="registryType" :registryDate="registryDate" :fiscalDestination="data.fiscalDestination" :mrn="mrn" :vesselProtocolLots="data.vesselProtocolLots"/>
                </template>
              </TabPanel>
            </TabView>
          </div>
        </div>
      </Panel>
    </div>
  </div>
</main>
</template>

<style lang="scss">
  .vessel-protocol {
    h4 {
      margin: 0;
    }
  }

  .tab .p-tabview-nav-link {
    margin: 0 0 -1px 0 !important;
  }
</style>
